module.exports = __webpack_public_path__ + "img/Mauricio.327778ec.jpg";